import React, { useEffect, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { CardTable } from "./CardTable";
import RadialGraph from "./Gauge";
import { extractDomain, processAlertsData } from "../../../utils/helpers";
import { useNavigate } from "react-router";
import { Button, Spinner } from "react-bootstrap";
import EmptyView from "../../../Component/EmptyView/EmptyView";
import { useSelector } from "react-redux";
import { getHomepageNews } from "../../../services/apiService";
import AiIcon from "../../../assets/svgs/AIIcon";
import Markdown from "markdown-to-jsx";
import classes from "./SummaryCard.module.css";
import MUIButton from "./../../../Component/UI/MUIButton/MUIButton";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import { PauseCircleFilled, RemoveCircleOutlined } from "@mui/icons-material";
import SourceModal from "./SourceModal";
import { getDefaultCase } from "../HomePage";
import { MONITORING_LLM_LABELS } from "../../../utils/constant";
import { getColorCode } from "../../../utils/monitoring-helpers";
import { dynamicReplace } from "../../Dashboard/Component/ActionComponent/ActionModal";

const ALERTS_RULE = [
  "Increase/Decrease RBI Score",
  "Increase/Decrease Core Attributes Score",
  "Increase/Decrease Purchase Criteria Score",
  "Increase/Decrease Positive Attribute Signal_Strength",
  "Increase/Decrease Negative Attribute Signal_Strength",
  "New Top 3 Positive Attributes",
  "New Top 3 Negative Attributes",
  "New Positive Attribute Arrival",
  "New Negative Attribute Arrival",
  "New Top 10 Branded Sources",
  "New Top 10 Non-Branded Sources",
];

const alertMetricsMapping = {
  avg_brand_index_score: "RBI Score",
  avg_brand_favorability_score: "Sentiment Score",
  avg_brand_reach_score: "Visibility Score",
};

const dateMapping = {
  Current: "Current",
  "3Days": "Last 3 Days",
  "7Days": "Last 7 Days",
  Month: "Last 30 Days",
  "3Month": "Last 90 Days",
};

const SummaryCard = ({ data, isProduct, domainUrl, frequency, llmDomains, dbLlms }) => {
  const navigate = useNavigate();
  const brands = useSelector((state) => state.brands);
  const brandProducts = useSelector((state) => state.brandProducts);
  const [news, setNews] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSourceModalOpen, setIsSourceModalOpen] = useState(false);
  const [sourceData, setSourceData] = useState([]);

  const handleClose = () => {
    setIsSourceModalOpen(false);
  };

  useEffect(() => {
    async function fetchNews() {
      if (isProduct) {
        const targetBrandProduct = brandProducts?.data?.data?.filter(
          (obj) => obj?.product?.name == data?.productName
        );
        if (targetBrandProduct && targetBrandProduct.length) {
          const payload = {
            frequency: dateMapping[frequency],
            category:
              targetBrandProduct?.[0]?.customer_brand_product_categories?.[0]
                ?.category?.name,
            entity: targetBrandProduct?.[0]?.product?.name,
            competitors:
              targetBrandProduct?.[0]?.customer_competitor_brand_products?.map(
                (obj) => obj?.brand_product?.name
              ),
            isBrand: !isProduct,
          };
          setIsLoading(true);
          const newsResp = await getHomepageNews(payload);
          setIsLoading(false);
          setNews(newsResp);
        }
      }
    }

    // fetchNews();
  }, [data]);

  async function fetchNews() {
    if (!isProduct) {
      const targetBrand = brands?.data?.data?.filter(
        (obj) => obj?.brand?.name == data?.brandName
      );

      if (targetBrand && targetBrand.length) {
        const payload = {
          frequency: dateMapping[frequency],
          category: targetBrand?.[0]?.category?.name,
          entity: targetBrand?.[0]?.brand?.name,
          competitors: targetBrand?.[0]?.competitors?.map(
            (obj) => obj?.brand?.name
          ),
          isBrand: !isProduct,
        };

        setIsLoading(true);
        const newsResp = await getHomepageNews(payload);
        setIsLoading(false);
        setNews(newsResp);
      }
    }
  }

  // useEffect(() => {
  //   fetchNews();
  // }, [data]);

  console.log('test==>', data)

  // Build LLM name -> provider map from dbLlms
  const llmProviderMap = (dbLlms || []).reduce((acc, llm) => {
    acc[llm.name] = llm.llm_provider || "Other";
    return acc;
  }, {});

  const mergedAlerts = processAlertsData(
    ALERTS_RULE,
    data,
    alertMetricsMapping,
    llmProviderMap
  );

  // const mergedAlerts = []

  // Current: average avg_brand_index_score across all LLMs in data.llms
  const currentLlmKeys = Object.keys(data?.llms || {});
  const avgBrandIndexScore = currentLlmKeys.length
    ? currentLlmKeys.reduce((sum, key) => sum + Number(data.llms[key]?.avg_brand_index_score || 0), 0) / currentLlmKeys.length
    : 0;

  // Past: get providers from current llms, then find matching pastLlms by provider
  const currentProviders = new Set(currentLlmKeys.map((key) => llmProviderMap[key]).filter(Boolean));
  const pastLlmKeys = Object.keys(data?.pastLlms || {});
  const matchingPastKeys = pastLlmKeys.filter((key) => currentProviders.has(llmProviderMap[key]));
  const pastAvgBrandIndexScore = matchingPastKeys.length
    ? matchingPastKeys.reduce((sum, key) => sum + Number(data.pastLlms[key]?.avg_brand_index_score || 0), 0) / matchingPastKeys.length
    : null;

    console.log('test==>', { avgBrandIndexScore, pastAvgBrandIndexScore, currentProviders, matchingPastKeys })

  // const handleNavigation = () => {
  //   const { personaName, geoName, marketName, categoryName } = data
  //   if (isProduct) {
  //     navigate(
  //       `/luminaire/product-monitoring?brandProductId=${data?.customerProductId}&dateRange=${frequency}`
  //     );
  //   } else {
  //     navigate(
  //       `/luminaire/brand-monitoring?brandId=${data?.customerBrandId}&dateRange=${frequency}`
  //     );
  //   }

  // };
  const handleNavigation = () => {
    const {
      personaName,
      geoName,
      marketName,
      categoryName,
      customerProductId,
      customerBrandId,
      llms = {}
    } = data;

    const llmName = Object.keys(llms || {})?.filter((item) => item !== 'gpt-4o-web-search')?.[0] || '';
    const queryParams = new URLSearchParams({
      dateRange: frequency,
      personaName,
      geoName,
      marketName,
      categoryName,
      llmName,
    });

    if (isProduct) {
      queryParams.set('brandProductId', customerProductId);
      navigate(`/luminaire/product-monitoring?${queryParams.toString()}`);
    } else {
      queryParams.set('brandId', customerBrandId);
      navigate(`/luminaire/brand-monitoring?${queryParams.toString()}`);
    }
  };

  const sentimentScores = Object.values(data?.llms || {})?.map(obj => obj?.avg_brand_favorability_score) || [];

  return (
    <div>
      <SourceModal
        open={isSourceModalOpen}
        handleClose={handleClose}
        data={sourceData}
      />
      <div class="mb-3 d-flex justify-content-between align-items-center">
        <div class="mb-3 d-flex align-items-center">
          <img
            style={{
              width: "32px",
              height: "28px",
              borderRadius: "6px",
              marginBottom: "8px", // Adds spacing between logo and text
            }}
            src={`https://img.logo.dev/${extractDomain(
              domainUrl
            )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
            alt={""}
          />
          &nbsp; &nbsp;
          <div style={{ display: 'flex' }}>
            <div style={{ textAlign: "left" }}>
              <span style={{ fontSize: "18px" }}>
                {" "}
                {isProduct ? data?.productName : data?.brandName}
              </span>

              <div className={classes.label_container}>
                <span className={classes.title_label}>{data?.categoryName}</span>
              </div>
            </div>

            <div style={{ marginLeft: '200px', textAlign: 'center' }}> <div>{getDefaultCase(data?.personaName, data?.geoName, data?.marketName)} </div>       {data?.runDate && (
              <div style={{ fontSize: "12px", color: "#666", marginTop: "-8px" }}>
                Last Updated: {new Date(data.runDate).toLocaleDateString("en-US")}
              </div>
            )}  </div>

          </div>

        </div>

        <Button
          style={{
            backgroundColor: "#007AFF",
            color: "#EFF4F8",
            fontSize: "14px",
            width: "120px",
            height: "35px",
            textAlign: "center",
          }}
          onClick={handleNavigation}
        >
          Monitoring
        </Button>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="graphGreyBg">
            <div class="row align-items-center justify-content-center">
              <div class="col reachCount">
                <p class="m-0"

                >
                  Visibility
                </p>
                <p 
                // style={{ color: getColorCode(data?.avgScores?.avg_brand_reach_score, 0, 'visibility') }} 
                class="m-0 prdCount">
                  {Number(data?.avgScores?.avg_brand_reach_score).toFixed(0)}
                </p>
              </div>
              <div class="col reachCount">
                <p class="m-0" style={{ color: "#292B2C" }}>
                  Sentiment
                </p>
                <p 
                // style={{ color: getColorCode(data?.avgScores?.avg_brand_favorability_score, Math.max(...sentimentScores)) }} 
                class="m-0 prdCount">
                  {Number(
                    data?.avgScores?.avg_brand_favorability_score
                  ).toFixed(0)}
                </p>
              </div>
            </div>
            <div class="d-flex align-items-center mt-3 flex-column mb-3">
              <p style={{ color: "#626262" }} class="mb-2">
                Brand Index Score
              </p>
              {/* <img src="images/graph1.png" class="w-100" /> */}
              <RadialGraph
                label={`Brand Index Score`}
                value={{
                  RBI: avgBrandIndexScore.toFixed(0),
                }}
                pastValue={pastAvgBrandIndexScore !== null ? {
                  RBI: pastAvgBrandIndexScore,
                } : null}
                Range={100}
                frequencyLabel={dateMapping[frequency]}
              />
            </div>
            <br />
            <br />
            <div style={{ marginTop: "-80px" }} class="graphsummary prdSummary">
              <CardTable llmDomains={llmDomains} llms={data?.llms} compLlms={data?.compLlms} />
            </div>
          </div>
        </div>

        <div className="col-md-8">
          <div className={classes.tableContainer}>
            <table className="table table-striped">
              <thead>
                <tr className="prdtblHeader">
                  {mergedAlerts && mergedAlerts?.length ? (
                    <>
                      <th style={{ width: "100px" }}></th>
                      <th>Alerts</th>
                    </>
                  ) : (
                    <th style={{ textAlign: "center" }}>Alerts</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {mergedAlerts && mergedAlerts?.length ? (
                  mergedAlerts?.map((dataObj) => {
                    const statusIconMapping = {
                      increased: (
                        <CheckCircleIcon style={{ color: "#36CFC2" }} />
                      ),
                      decreased: <CancelIcon style={{ color: "#FC4C4E" }} />,
                      default: dataObj?.isPositive ? (
                        // <CheckCircleIcon style={{ color: "#36CFC2" }} />
                        <RemoveCircleOutlined style={{ color: "darkgrey" }} />
                      ) : (
                        // <CancelIcon style={{ color: "#FC4C4E" }} />
                        <RemoveCircleOutlined style={{ color: "darkgrey" }} />
                      ),
                    };
                    return (
                      <tr>
                        <td class="text-center" valign="middle">
                          {statusIconMapping[dataObj?.status] ||
                            statusIconMapping.default}
                        </td>
                        <td style={{ display: "flex", alignItems: "center" }}>
                          <img
                            className={
                              dataObj?.llmName !== "llm-web"
                                ? classes.logo4
                                : classes.logo3
                            }
                            src={
                              dataObj?.llmName === "llm-web"
                                ? "/menu.png"
                                : extractDomain(
                                  llmDomains?.[dataObj?.llmName]
                                ) === "google.com"
                                  ? "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg"
                                  : `https://img.logo.dev/${extractDomain(
                                    llmDomains?.[dataObj?.llmName]
                                  )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`
                            }
                            alt={""}
                          />
                          &nbsp; &nbsp;
                          {dataObj?.message ? (
                            <span style={{ flex: "1" }}>
                              {dynamicReplace(dataObj?.message)}
                            </span>
                          ) : (
                            <>
                              <span> {MONITORING_LLM_LABELS?.[dataObj?.llmName] || dataObj?.llmName} - </span> &nbsp;
                              <span
                                onClick={() => {
                                  setIsSourceModalOpen(true);
                                  setSourceData(dataObj?.newSources);
                                }}
                                style={{ cursor: "pointer", color: "blue" }}
                              >
                                {`New ${dataObj?.isBranded
                                  ? "Brand Query"
                                  : "Category Query"
                                  } Sources in Top 10`}
                              </span>
                              &nbsp; Vs &nbsp;
                              <span
                                onClick={() => {
                                  setIsSourceModalOpen(true);
                                  setSourceData(dataObj?.replacedSources);
                                }}
                                style={{ cursor: "pointer", color: "blue" }}
                              >
                                Replaced
                              </span>
                            </>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td style={{ textAlign: "center" }}>
                      <EmptyView message="Alerts Not Available" />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* <p></p>
      <div class="row">
        <div className="col-md-12">
          <div className={`${classes.tableContainer} graphGreyBg`}>
            <p className="mb-3 font14-600">
              News &nbsp; &nbsp;
              <MUIButton
                onClick={fetchNews}
                variant="outlined"
                className={classes.regenerate}
                startIcon={<AutoAwesomeOutlinedIcon />}
              >
                Generate
              </MUIButton>
            </p>
            <div className="graphsummary font-11">
              {isLoading ? (
                <span style={{ display: "flex", justifyContent: "center" }}>
                  <Spinner />
                </span>
              ) : news && typeof news === "string" ? (
                <Markdown className="markTable">{news}</Markdown>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default SummaryCard;
